import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class EventObserver {
    constructor() { }

    private EventObserverService = new Subject<any>();

    publishData(data: any) {
        this.EventObserverService.next(data);
    }

    getObservable(): Subject<any> {
        return this.EventObserverService;
    }
}